import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '@services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-get-points-modal',
  templateUrl: './get-points-modal.component.html',
  styleUrls: ['./get-points-modal.component.scss']
})
export class GetPointsModalComponent implements OnInit, OnDestroy {

  @ViewChild('showGetPointModal', { static: true }) modal: any;
  private showGetPointsModalSubscription: Subscription = null;

  constructor(private modalService: NgbModal, public sharedService: SharedService) { }

  ngOnInit(): void {
    
    this.showGetPointsModalSubscription = this.sharedService.showGetPointsModal.subscribe(show => {

      // Clean Modals
      this.closeModal();      
      if (show) this.openModal();
    });
  }

  ngOnDestroy() {

    if (this.showGetPointsModalSubscription) { this.showGetPointsModalSubscription.unsubscribe(); }
  }

  openModal() {
    this.modalService.open(this.modal, {
      backdrop: 'static', keyboard: false,
      size: 'lg', centered: true, windowClass: 'modal-full'
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}
